import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Helper } from "../core/util/helper.js";
import React from "react"

export class ApplicationRestartHelper {
    private static startTimer = (duration: number, text: JQuery<HTMLElement>) => {
        let start = Date.now();
        let diff: number;
        let minutes: number | string;
        let seconds: number | string;
        let id: number;
        const timer = () => {
            // get the number of seconds that have elapsed since 
            // startTimer() was called
            diff = duration - (((Date.now() - start) / 1000) | 0);

            // does the same job as parseInt truncates the float
            minutes = (diff / 60) | 0;
            seconds = (diff % 60) | 0;

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            if (diff <= 0) {
                //disable timer
                clearInterval(id);
                //update gui
                text[0].textContent = Helper.getTranslation("WebCRM.Administration.Restarting");
                kendo.ui.progress($("#globalBusyIndicator"), true);
                ApplicationRestartHelper.setGrayscale();
                //call reload after 10 sec 
                setTimeout(() => {
                    window.location.reload();
                }, 10000);
            } else
                text[0].textContent = Helper.getTranslation("WebCRM.Administration.RestartCountDown") + " " + minutes + ":" + seconds;

        }
        // we don't want to wait a full second before the timer starts
        timer();
        id = setInterval(timer, 1000);
    }

    public static removeWarning = () => {
        const el = $("#header-warning");
        if (el != null && el.children().length > 0) {
            el.children().remove();
        }
    }
    public static processHeartbeat = (restartUtc: string) => {
        if (Helper.hasValue(restartUtc)) {
            // find warning div in header
            const el = $("#header-warning");
            //found? maybe already with message?
            if (el.length == 1 && el.children().length == 0) {
                //add in DOM
                const warning =
                    $(`<div id="reset-countdown" class='reset-countdown'>
                                <i class='fal fa-fw fa-exclamation-circle' id='reset-countdown-icon' aria-hidden='true'/> 
                                <span id='reset-countdown-text'></span>
                            </div>`);
                el.append(warning);
                //start countdown 
                const diff = Math.abs(new Date().getTime() - kendo.parseDate(restartUtc).getTime()) / 1000;
                ApplicationRestartHelper.startTimer(diff, $("#reset-countdown-text"));
            }
        }
    }

    private static setGrayscale = () => {
        const elements: string[] = ["header", "main"];
        elements.forEach(e => {
            const el = $('#' + e);
            if (el.length == 1)
                el[0].style.filter = "grayscale(90%)";
        })
    }
}
export class ApplicationRestartApp extends React.Component<ApplicationRestartAppProps, any> {
    common = new AppHelper();

    constructor(props: ApplicationRestartAppProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    restart = async () => {
        this.common.setEntityDirtyState(false);
        const result = await HTTPService.post<JsonResultClass>("ApplicationRestart/Restart",
            { timeOut: this.props.entity.timeOut })
        if (result.Code == 0) {
            ApplicationRestartHelper.processHeartbeat(result.Data);
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
}

export interface ApplicationRestartEntity extends Entity {
    timeOut: number;
}
export interface ApplicationRestartAppProps extends AppBaseProps {
    entity: ApplicationRestartEntity;
}
